import { render, staticRenderFns } from "./ass-setting.vue?vue&type=template&id=5b2fb902&scoped=true"
import script from "./ass-setting.vue?vue&type=script&lang=js"
export * from "./ass-setting.vue?vue&type=script&lang=js"
import style0 from "./ass-setting.vue?vue&type=style&index=0&id=5b2fb902&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2fb902",
  null
  
)

export default component.exports